import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn:false,
  showLoader: false,
  userdetail: {},
  approvePopupOpen:false,
  addNotePopupOpen:false,
  isUploadPopupOpen:false,
  isViewNotePopupOpen:false,
  isUploadPhotoPopupOpen:false,
};

export const mainSlice = createSlice({
  name: "mainSlice",
  initialState,
  reducers: {
    resetState: () => initialState,
    showLoader: (state) => {
      state.showLoader = true;
    },
    hideLoader: (state) => {
      state.showLoader = false;
    },
    setUserDetail: (state, action) => {
      state.userdetail = action.payload;
    },
    setIsLoggedIn(state,action){
      state.isLoggedIn = action.payload
    },
    setApprovePopUpOPen(state,action){
      state.approvePopupOpen = action.payload
    },
    setAddNotePopupOpen(state,action){
      state.addNotePopupOpen = action.payload
    },
    setUploadPopupOpen(state,action){
      state.isUploadPopupOpen = action.payload
    },
    setViewNotePopoup(state,action){
      state.isViewNotePopupOpen = action.payload
    },
    setUploadPhotoPopupOpen(state,action){
      state.isUploadPhotoPopupOpen = action.payload
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  resetState,
  showLoader,
  hideLoader,
  setUserDetail,
  setIsLoggedIn,
  setApprovePopUpOPen,
  setAddNotePopupOpen,
  setUploadPopupOpen,
  setViewNotePopoup,
  setUploadPhotoPopupOpen
} = mainSlice.actions;

export default mainSlice.reducer;
